import ApiService from '@/services/api.service';

export const sessions = {
  namespaced: true,
  state: {
    diplomeSessions: [],
    actionSessions: [],
    allSessions: [],
  },
  getters: {
    getAllSessions: (state) => state.allSessions,
    getDiplomeSessions: (state) => state.diplomeSessions,
    getActionSessions: (state) => state.actionSessions,
    getSessionById: (state) => (id) => {
      return state.allSessions.find((session) => session.id === id);
    },
  },
  mutations: {
    SET_DIPLOME_SESSIONS(state, payload) {
      state.diplomeSessions = payload;
      // Rebuild allSessions to ensure consistency
      state.allSessions = [...state.actionSessions, ...state.diplomeSessions];
    },
    SET_ACTION_SESSIONS(state, payload) {
      state.actionSessions = payload;
      // Rebuild allSessions to ensure consistency
      state.allSessions = [...state.actionSessions, ...state.diplomeSessions];
    },
    SET_ALL_SESSIONS(state, payload) {
      state.allSessions = payload;
    }
  },
  actions: {
    /**
     * Fetch diploma sessions for the scheduler.
     * @param {object} context
     * @param {object} params - Optional params.
     */
    async fetchDiplomeSessions({ commit }, params = {}) {
      const response = await ApiService.getRequest('diplome_sessions_scheduler', params);
      const data = response.data['hydra:member'];
      commit('SET_DIPLOME_SESSIONS', data);
      return data;
    },

    /**
     * Fetch action sessions for the scheduler.
     * @param {object} context
     * @param {object} params - Optional params.
     */
    async fetchActionSessions({ commit }, params = {}) {
      const response = await ApiService.getRequest('action_sessions', params);
      const data = response.data['hydra:member'];
      commit('SET_ACTION_SESSIONS', data);
      return data;
    },

    /**
     * Fetch "antenne" action sessions.
     * @param {object} context
     * @param {object} params - Optional params.
     */
    async fetchAntenneActionSessions({ commit }, params = {}) {
      const response = await ApiService.getRequest('antenne_action_sessions', params);
      return response.data['hydra:member'];
    },

    /**
     * Fetch "antenne" diploma sessions.
     * @param {object} context
     * @param {object} params - Optional params.
     */
    async fetchAntenneDiplomeSessions({ commit }, params = {}) {
      const response = await ApiService.getRequest('antenne_diplome_sessions', params);
      return response.data['hydra:member'];
    },
  }
};
